import { render } from "./AppTextArea.vue?vue&type=template&id=12e61770"
import script from "./AppTextArea.vue?vue&type=script&lang=ts"
export * from "./AppTextArea.vue?vue&type=script&lang=ts"
script.render = render

export default script